<template>
  <div class="row">
    <div class="col-12">
      <page-header :page="page" />
    </div>
    <div class="col-12 flip-cards-container">
      <square-option
        v-for="option in optionList"
        :key="option.id"
        :option="option"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import PageHeader from 'PageHeader'
import SquareOption from '@/components/common/menu/SquareOption.vue'
import { name as userModuleName } from '@/modules/user/store'
import { name as commonModuleName } from '@/modules/common/store'
import navMenuTitles from '@/utils/constants/navMenuTitles'

export default {
  components: {
    SquareOption,
    PageHeader,
  },
  data() {
    return {
      page: {
        icon: 'far fa-file-chart-line mx-1',
        title: '618 Data',
        routes: ['Inicio', '618 Data'],
      },
    }
  },
  computed: {
    ...mapState(userModuleName, ['userMenu']),
    ...mapGetters(commonModuleName, ['getFilterText']),
    optionList() {
      const items =
        this.userMenu
          .find((x) => x.title === navMenuTitles.Eden)
          ?.children.map((item) => ({
            title: item.title,
            description: item.description,
            detail: item.detail,
            icon: item.iconClasses,
            mainImage: item.mainImagePath,
            hoverImage: item.mainImageHoverPath,
            needSelectedStudent: item.needSelectedStudent,
            route: item.navigationPath,
          })) || []

      const filteredItems = this.getFilterText
        ? items?.filter((e) =>
            e.title.toLowerCase().match(this.getFilterText.toLowerCase())
          )
        : items

      return filteredItems
    },
  },
  methods: {
    ...mapActions(commonModuleName, ['setFilterText']),
  },
  beforeRouteLeave(to, from, next) {
    this.setFilterText('')
    next()
  },
}
</script>
<style scoped>
::v-deep .dot.text-center > i {
  padding-right: 0px !important;
  font-size: 20pt !important;
  margin: 0px 6px !important;
}
</style>
